import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanEditProvider = (providerId: number): boolean => {
  const [canEditProvider, setCanEditProvider] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const editProviderPermission: Permission = {
    resource: 'providers',
    action: 'updatebasic',
    scope: 'provider',
  };
  const editAllPermission: Permission = {
    resource: 'providers',
    action: 'updatebasic',
    scope: 'all',
  };

  const canEditSelf = useHasPermission(user, editProviderPermission);
  const canEditAll = useHasPermission(user, editAllPermission);

  React.useEffect(() => {
    setCanEditProvider(
      canEditAll ||
        (canEditSelf && providerId === user.transportationProviderID),
    );
  }, [canEditAll, canEditSelf]);

  return canEditProvider;
};
